import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import HuchaStandardCard from './hucha-standard-card/hucha-standard-card';
import HuchaRenovadoresCard from './hucha-renovadores-card/hucha-renovadores-card';

export const HuchaCard = ({ huchaValues }: { huchaValues: HuchaValues | null }): React.ReactElement => {
	if (huchaValues?.huchaTier !== 'standard') {
		return <HuchaRenovadoresCard huchaValues={huchaValues} />;
	}
	return <HuchaStandardCard huchaValues={huchaValues} />;
};
